import React from "react";
import { Box, Skeleton } from "@mui/material";

export const AiSkeletonLoader: React.FC = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        padding: 2,
        backgroundColor: "#f5f5f5",
        borderRadius: "10px",
        mb: "20px"
      }}
    >
      <Skeleton variant="rectangular" width="80%" height={30} animation="wave" />
      {Array.from({ length: 1 }).map(
        // change length number if case to change rows number
        (_, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            width={`${Math.random() * (90 - 50) + 50}%`}
            height={20}
            animation="wave"
          />
        )
      )}
      <Skeleton variant="rectangular" width="30%" height={25} animation="wave" />
    </Box>
  );
};
